import { lazy, Suspense } from 'react';
import { AdminLayout } from 'components/themes/admin';

const AdminJobsArchive = lazy(() => import('modules/admin/Job/AdminJobsArchive'));

const AdminJobsArchivePage = (props) => (
  <AdminLayout>
    <Suspense fallback={null}>
      <AdminJobsArchive />
    </Suspense>
  </AdminLayout>
);

export default AdminJobsArchivePage;
